// Farm options shared by General Settings and the system admin's tenant form
export const TIMEZONES = [
  'America/Mexico_City',
  'UTC',
  'America/New_York',
  'America/Los_Angeles',
  'Europe/London',
  'Europe/Berlin',
  'Asia/Tokyo',
  'Asia/Shanghai',
  'Asia/Kolkata'
]

export const COUNTRIES = [
  { value: 'Mexico', label: 'México' },
  { value: 'USA', label: 'Estados Unidos' },
  { value: 'Canada', label: 'Canadá' }
]

export const CURRENCIES = ['MXN', 'EUR', 'USD', 'ILS']

export const MONTHS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
